__turbopack_context__.v({
  "content": "CoreRichText-module-scss-module__xmlAtW__content",
  "description": "CoreRichText-module-scss-module__xmlAtW__description",
  "eyebrow": "CoreRichText-module-scss-module__xmlAtW__eyebrow",
  "heading": "CoreRichText-module-scss-module__xmlAtW__heading",
  "main": "CoreRichText-module-scss-module__xmlAtW__main",
  "pdf": "CoreRichText-module-scss-module__xmlAtW__pdf",
  "slide-down": "CoreRichText-module-scss-module__xmlAtW__slide-down",
  "slide-up": "CoreRichText-module-scss-module__xmlAtW__slide-up",
});
